import { BalanceSource } from 'components/ButtonAddBalance'
import sendData from '../../../../utils/sendData'

export const success = (source: BalanceSource) => {
  sendData('account.finance.add_funds.page_load.success', { source })
}
